import React, { useState, useEffect, Fragment } from 'react';
import { withFormik } from "formik";
import * as Yup from "yup";
import DateTimePicker from "react-datetime-picker";

import FormikTextarea from "../Forms/FormikFormGroup/FormikTextarea";
import BasicDropdown from "../Forms/BasicDropdown";
import RadioButtons from "../Forms/RadioButtons";
import NumberDropdown from "../Forms/NumberDropdown";

import { EllipsisLoader } from "../Loaders";
import SvgIcon from "../Icons";
import { EventTypesOptions, timeStamps } from "./data";

import './index.sass';


const EventDetailsStepWrapper = ({ closeMobileForm,
                                   errors,
                                   handleBlur,
                                   handleChange,
                                   handleSubmit,
                                   goBack,
                                   loading,
                                   placeName,
                                   resetForm,
                                   resetTrigger,
                                   setValidationTrigger,
                                   setFieldValue,
                                   submitButtonText,
                                   submitStep,
                                   touched,
                                   validationTrigger,
                                   values,
                                 }) => {

  const [isFlexibleDate, setIsFlexibleDate] = useState(false);
  const [showComment, setShowComment] = useState(null);

  useEffect(() => {
    if (validationTrigger) {
      submitStep(values);
      goBack();
    }
  }, [validationTrigger]);


  useEffect(() => {
    validationTrigger && setValidationTrigger(false);
  }, [errors]);


  useEffect(() => {
    if (resetTrigger) {
      resetForm();
      resetTrigger();
    }
  }, [resetTrigger]);


  useEffect(() => {
    const { event_date, event_optional_date, event_time } = values;

    if (event_optional_date && (event_date || event_time)) {
      event_date && setFieldValue('event_date', '');
      event_time && setFieldValue('event_time', '');
    }

  }, [values.event_optional_date]);


  useEffect(() => {
    const { event_date, event_optional_date, event_time } = values;

    (event_date || event_time) && event_optional_date && setFieldValue('event_optional_date', '');

  }, [values.event_date, values.event_time]);


  const handleCancel = () => {
    closeMobileForm();
  };


  const timeOptions = timeStamps.map(time => ({ id: time }));

  const dateStateOptions = [
    { label: 'Fast dato', value: false, checked: !isFlexibleDate },
    { label: 'Fleksibel dato', value: true, checked: isFlexibleDate },
  ];


  return (
    <form name="bookingFormFirstStep" className="booking-form-first-step" onSubmit={handleSubmit}>
      <input
        id="fifth_element"
        type="text"
        name="fifth_element"
        className="invisible"
        value={values.fifth_element}
        onPaste={handleChange}
        onChange={handleChange}
      />

      <BasicDropdown
        currentValue={EventTypesOptions.find(option => option.id === values.event_type)}
        handleChange={(value) => setFieldValue('event_type', value.id)}
        options={EventTypesOptions}
        placeholder={'Begivenhed'}
        triggerIcon="fest"
        wrapperClass="event_kind"
      />

      <NumberDropdown
        bodyLabel="Vælg antal gæster"
        id="guests"
        handleChange={(value) => setFieldValue('guests', value)}
        label="gæster"
        placeholder="Antal"
        triggerIcon="users2"
        value={values.guests}
        wrapperClass={`guests-number booking-form__guests consistent`}
      />

      <div className="booking-form__date-picker">

        <RadioButtons
          name="accountType"
          options={dateStateOptions}
          handleChange={(value) => setIsFlexibleDate(value)}
        />

        <div className={`booking-form__fixed-date-wrapper ${isFlexibleDate ? 'disabled' : ''}`}>
          <DateTimePicker
            calendarIcon={<SvgIcon name="calendar" size={24} fill="#E8753D" />}
            className={values.event_date ? 'active' : ''}
            clearIcon={null}
            dayPlaceholder=""
            disableClock={true}
            format="dd-MM-yyyy"
            minDate={new Date()}
            monthPlaceholder=""
            onChange={(value) => setFieldValue('event_date', value)}
            showLeadingZeros={false}
            value={values.event_date}
            yearPlaceholder=""
          />

          <div className="booking-form__fixed-date-divider" />

          <BasicDropdown
            currentValue={timeOptions.find(option => option.id === values.event_time)}
            handleChange={(value) => setFieldValue('event_time', value.id)}
            options={timeOptions}
            placeholder={'Tid'}
            triggerIcon="clock_outline"
            wrapperClass="time"
          />

          <div className="booking-form__fixed-date-border" />
        </div>

        { isFlexibleDate &&
          <div className="booking-form__flexible-date-wrapper">
            <FormikTextarea
              id="event_optional_date"
              error={errors.message}
              handleBlur={handleBlur}
              handleChange={handleChange}
              maxLength={150}
              placeholder={`Skriv ønsker til dagen....`}
              showCount={true}
              touched={touched.event_optional_date}
              value={values.event_optional_date}
              wrapperClass="optional-date"
            />

            <p className="booking-form__flexible-date-sub">
              Tilføi flere detalier til den fleksible dato (F.eks. alle fredage i januar)
            </p>
          </div>
        }

        <div className="booking-form__date-border" />
      </div>

      <div className="booking-form__comment-wrapper">
        <div className={`booking-form__comment-trigger ${showComment ? '' : 'active'}`} onClick={() => setShowComment(true)}>
          { !showComment && <SvgIcon name="add_box" size={24} /> }
          { showComment ? 'Del dine ønsker med os!' : 'Tilføj kommentar' }
        </div>

        { (showComment || values.message) &&
          <Fragment>
            <FormikTextarea
              id="message"
              error={errors.message}
              handleBlur={handleBlur}
              handleChange={handleChange}
              maxLength={150}
              placeholder={`Evt. besked til ${placeName}`}
              showCount={true}
              touched={touched.message}
              value={values.message}
            />
            <div className="booking-form__comment-cancel-btn"
                 role="hide-after-click"
                 onClick={() => {
                   setFieldValue('message', '');
                   setShowComment(false);
                 }}
            >
              Annullér
            </div>
          </Fragment>
        }
      </div>

      <div className="booking-form__submit-wrapper">
        <div className={`booking-form__mobile-back-button ${loading ? 'inactive' : ''}`}
                onClick={() => goBack ? submitStep(null, 1) : handleCancel()}>
          { goBack ? 'Tilbage' : 'Annullér' }
        </div>

        <button type="submit" className={`booking-form__submit-button ${loading ? 'inactive' : ''}`}>
          { loading ? <EllipsisLoader /> : submitButtonText }
        </button>

      </div>

    </form>
  )
};


const EventDetailsStep = withFormik({

  mapPropsToValues: (bag) => ({
    event_date: bag.currentValues.event_date || '',
    event_optional_date: bag.currentValues.event_optional_date || '',
    event_time: bag.currentValues.event_time || '',
    event_type: bag.currentValues.event_type || '',
    fifth_element: bag.currentValues.fifth_element || '',
    guests: bag.currentValues.guests || '',
    message: bag.currentValues.message || '',
  }),

  validationSchema: Yup.object().shape({
    event_date: Yup.string(),
    event_optional_date: Yup.string(),
    event_time: Yup.string(),
    event_type: Yup.string(),
    fifth_element: Yup.string(),
    guests: Yup.string(),
    message: Yup.string(),
  }),

  handleSubmit: (values, bag) => {
    bag.props.submitStep(values);
  },

  displayName: 'BookingFormFirstStep',
})(EventDetailsStepWrapper);

export default EventDetailsStep;
